<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="work-flow-ser-title" :field="fields?.title" tag="h2" />
      <div class="work-flow-ser-content" v-if="fields?.stepImage">
        <AdaptiveImage
          class="work-flow-ser-content-stepimage"
          :field="fields?.stepImage"
          :isBackground="false"
          :lazy-load="false"
          :enableScrollDetection="false"
          :show="true"
        />
        <div class="work-flow-ser-step" v-if="fields?.stepList?.length">
          <div
            class="work-flow-ser-step-item"
            v-for="(item, index) in fields?.stepList"
            :key="index"
          >
            <div class="work-flow-ser-step-item-title">
              <JssRichText :field="item?.fields?.title" />
            </div>
            <JssRichText class="work-flow-ser-step-item-subtitle" :field="item?.fields?.subtitle" />
          </div>
        </div>
      </div>
      <div class="work-flow-ser-card" v-if="fields?.cardList?.length">
        <JssRichText class="work-flow-ser-card-title" :field="fields?.cardTitle" />
        <div class="work-flow-ser-card-content">
          <div
            class="work-flow-ser-card-item"
            v-for="(item, index) in fields?.cardList"
            :key="index"
          >
            <div class="work-flow-ser-card-item-header">
              <JssRichText class="work-flow-ser-card-item-title" :field="item?.fields?.title" />
              <JssRichText
                class="work-flow-ser-card-item-subtitle"
                :field="item?.fields?.subtitle"
              />
            </div>
            <JssRichText class="work-flow-ser-card-item-desc" :field="item?.fields?.desc" />
            <div class="work-flow-ser-card-item-time-container">
              <JssRichText class="work-flow-ser-card-item-time" :field="item?.fields?.time" />
            </div>
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'WorkflowSer',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'work-flow-ser'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.work-flow-ser {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;
    margin-top: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    &-stepimage {
      width: 1135px;
      height: auto;
    }
  }

  &-step {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    gap: 10px;
    min-width: 1000px;

    &-item {
      position: relative;
      width: 190px;

      &:not(:first-child) {
        margin-left: -3px;

        .work-flow-ser-step-item-title {
          border-radius: 0;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid $white;
          }
        }
      }

      &-title {
        font-size: 14px;
        line-height: 1.2;
        font-weight: 700;
        color: $grey-black;
        background: #efeadf;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 8px 0 0 8px;
        padding-left: 30px;

        &::after {
          content: '';
          position: absolute;
          right: -20px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 20px solid transparent;
          border-bottom: 20px solid transparent;
          border-left: 20px solid #efeadf;
          z-index: 1;
        }
      }

      &-subtitle {
        font-size: 14px;
        color: $grey-black;
        line-height: 1.2;
        margin: 6px 0 0 30px;

        li + li {
          margin-top: 3px;
        }

        p + p {
          margin-top: 3px;
        }
      }
    }
  }

  &-card {
    padding: 32px;
    background: #f6faf9;
    border-radius: 16px;
    margin-top: 16px;

    &-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.2;
      color: $grey-black;
      text-align: center;
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin-top: 25px;
    }

    &-item {
      flex: 1;
      padding: 24px;
      background: $white;
      border-radius: 16px;

      &-header {
        background: rgba($blue-night, 0.1);
        padding: 16px;
        border-radius: 8px;
      }

      &-title {
        font-size: 18px;
        line-height: 1.2;
        font-weight: 700;
        color: $grey-black;
      }

      &-subtitle {
        font-size: 14px;
        color: $grey-black;
        line-height: 1.2;
        margin-top: 12px;
        color: $grey-black;
      }

      &-desc {
        font-size: 18px;
        color: $grey-black;
        line-height: 1.2;
        margin-top: 16px;
        font-weight: 700;
      }

      &-time-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &-time {
        font-size: 14px;
        line-height: 1.2;
        margin-top: 12px;
        color: $grey-black;
        background: rgba($blue-night, 0.1);
        padding: 4px 8px;
        display: inline-block;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      &-stepimage {
        width: 100%;
      }
    }

    &-card {
      &-content {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
        grid-template-rows: auto auto auto;
        column-gap: 24px;
        row-gap: 16px;
      }

      &-item {
        display: grid;
        grid-template-rows: subgrid;
        grid-row: span 3;

        &-desc {
          margin-top: 0;
        }

        &-time {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
